const COOKIE_NAME = 'KG_CONSENT';
const CATEGORY_NAME = 'analyzing_cookies';
const BUTTON_CLASSES = ['btn', 'button'];

const SELECTORS = {
    LINKS: 'a[href]:not(.js-lazyload-external-video-link)',
    // eslint-disable-next-line max-len
    BUTTONS: 'button:not(.js-faq-overview-question-toggle):not(.js-collapsible-content-toggle), input[type=button], input[type=submit]',
    SEARCH: '.js-header-search',
};

class Datalayers {
    constructor(parent = document.body) {
        this.parent = parent;
        this.consented = lookUpCookie();
        this.dataLayerIncluded = typeof window.dataLayer !== 'undefined';

        this.handleLinks.bind(this);
        this.handleButtons.bind(this);
        this.pushData.bind(this);
        this.handleHeaderSearch.bind(this);
    }

    pushData(data) {
        if (typeof data === 'object' && window.dataLayer && this.consented) {
            window.dataLayer.push(data);
        }
    }

    init() {
        if (this.dataLayerIncluded) {
            this.handleLinks();
            this.handleButtons();
            this.handleHeaderSearch();
        }
    }

    handleLinks() {
        const links = [...this.parent.querySelectorAll(SELECTORS.LINKS)];

        if (links) {
            links.forEach((link) => {
                link.addEventListener('click', (e) => {
                    const { href, host } = e.currentTarget;

                    if (href !== '') {
                        if (href.match(/^mailto:/i)) {
                            this.pushData({
                                event: 'contact',
                                eventAction: 'mail',
                                mailUrl: href.replace(/^mailto:([^?]+).*/, '$1'),
                            });
                        }

                        if (href.match(/^tel:/i)) {
                            this.pushData({
                                event: 'contact',
                                eventAction: 'call',
                                mailUrl: href.replace(/^tel:([^?]+).*/, '$1'),
                            });
                        }

                        if (link.classList.contains('js-download-link')) {
                            this.pushData({
                                event: 'download',
                                downloadUrl: href,
                            });
                        }

                        if (link.classList.contains(...BUTTON_CLASSES)) {
                            const innerContent = link.querySelector('.btn__inner');
                            const text = innerContent ? innerContent.textContent : link.textContent;

                            this.pushData({
                                event: 'button',
                                buttonText: text,
                            });
                        }

                        if (host !== window.location.host) {
                            this.pushData({
                                event: 'outgoing',
                                linkUrl: href,
                            });
                        }
                    }
                });
            });
        }
    }

    handleButtons() {
        const buttons = [...this.parent.querySelectorAll(SELECTORS.BUTTONS)];

        if (buttons) {
            buttons.forEach((button) => {
                button.addEventListener('click', ({ currentTarget: element }) => {
                    let label;
                    if (element.nodeName === 'INPUT') {
                        label = element.value;
                    } else {
                        label = element.textContent;
                    }

                    this.pushData({
                        event: 'button',
                        buttonText: label,
                    });
                });
            });
        }
    }

    handleHeaderSearch() {
        const form = this.parent.querySelector(SELECTORS.SEARCH);

        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                const { value } = form.elements[0];

                this.pushData({
                    event: 'search',
                    searchTerm: value,
                });

                form.submit();
            });
        }
    }
}

function lookUpCookie() {
    const match = document.cookie.match(new RegExp(`(^| )${COOKIE_NAME}=([^;]+)`));
    if (match) {
        return match.input.includes(CATEGORY_NAME);
    }

    return false;
}

function initDataLayers() {
    const dataLayers = new Datalayers();

    if (dataLayers.consented) {
        dataLayers.init();
    }
}

export { initDataLayers, Datalayers };
